import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const OnlineUserItem = ({ user }) => {
  return (
    <Fragment>
      {user.role === "innovator" && (
        <Link to={`/liveonime/innovators/${user.channelid}`}>
          <div className="online-user green">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                    className="drop-down-result-avi"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font">{user.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                </ul>
              </div>
            </div>
            <div className="online-info-desc">
              <i className="fas fa-circle fa-sm green pt"></i>
              <p className="online-text">{user.description}</p>
            </div>
          </div>
        </Link>
      )}
      {user.role === "mentor" && (
        <Link to={`/liveonime/mentors/${user.channelid}`}>
          <div className="online-user red">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border red">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                    className="drop-down-result-avi"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font">{user.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                </ul>
              </div>
            </div>
            <div className="online-info-desc">
              <i className="fas fa-circle fa-sm red pt"></i>
              <p className="online-text">{user.description}</p>
            </div>
          </div>
        </Link>
      )}
      {user.role === "employer" && (
        <Link to={`/liveonime/employers/${user.channelid}`}>
          <div className="online-user blue">
            <div className="flex-only">
              <div className="online-avi-container">
                <div className="avi-color-border blue">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                    className="drop-down-result-avi"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">{user.companyname}</span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                </ul>
              </div>
            </div>
            <div className="online-info-desc">
              <i className="fas fa-circle fa-sm blue pt"></i>
              <p className="online-text">{user.description}</p>
            </div>
          </div>
        </Link>
      )}
    </Fragment>
  );
};

export default OnlineUserItem;
